import Yup from 'utils/yup'

export const defaultValues = {
  name: null,
  active: false,
}

export const validationSchema = Yup.object().shape({
  name: Yup.string().nullable().required().max(40, 'O nome deve ter no máximo 40 caracteres'),
  active: Yup.bool().nullable().required(),
})
